import { styled } from 'styled-components'
import { Block } from 'suomifi-ui-components'
import media from 'common-ui-components/src/vtj/theme/media'
import { TextBlockWithRows } from 'todistukset-ui/src/vtj/components/page-content/PageContent.sc'

export const CertificateItemList = styled.ul`
  list-style-type: disc;
  list-style-position: inside;
  & > li {
    padding: 0;
  }
`

export const Intro = styled(Block)`
  white-space: pre-wrap;
  ul {
    list-style-type: disc;
    list-style-position: inside;
    margin-bottom: ${(props) => props.theme.spacing.m};
  }

  p + p,
  p + ul.fi-link-list {
    margin-top: ${(props) => props.theme.spacing.m};
  }
`

export const PriceListContainer = styled(TextBlockWithRows)`
  width: 100%;
`

export const CertificateTypeList = styled(CertificateItemList)`
  width: 100%;
  display: flex;
  flex-flow: column wrap;
  gap: 0px ${(props) => props.theme.spacing.xl};
  align-content: flex-start;

  height: 5.75rem;
  ${media.mobileAndTablet} {
    height: auto;
  }
  & > li {
    margin: 0;
    padding: 0 ${(props) => props.theme.spacing.s};
  }
`
